import { SearchConsoleAccountsFormSecondStepValidationSchema } from '../../../../../searchConsole.interfaces';


export const searchConsoleAccountsFormSecondStepValidationSchema: SearchConsoleAccountsFormSecondStepValidationSchema = {
  clientId: [
    { required: true, message: 'Введіть ID користувача' },
    { type: 'string', message: 'ID користувача має бути строкою' },
    { min: 1, max: 255, message: 'ID користувача має бути довжиною не менше 1 символа та не більше 255' }
  ],
  clientSecret: [
    { required: true, message: 'Введіть секретну фразу користувача' },
    { type: 'string', message: 'Секретна фраза має бути строкою' },
    { min: 1, max: 255, message: 'Секретна фраза має бути довжиною не менше 1 символа та не більше 255' }
  ]
};
